import { render, staticRenderFns } from "./UnionIcon.vue?vue&type=template&id=44163b9e&lang=pug"
import script from "./UnionIcon.vue?vue&type=script&lang=ts"
export * from "./UnionIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports